import Component from "../../lib/component";
import {TogglerBtnsConfig} from "./toggler_btns";

export const TogglerPanesConfig = {
    baseHtmlClass: 'toggler_btns_panes',
    selector: '.toggler_btns_panes',
};

function getPanesHeight(togglerPanes) {
    let height = togglerPanes.togglerBtns.element.dataset[TogglerBtnsConfig.panesHeightDatasetKey];
    height = Number.parseInt(height)
    return Number.isNaN(height) ? null : height;
}

export class TogglerPanes extends Component {

    constructor(id_or_element, togglerBtns) {
        super({
            element: id_or_element,
            config: TogglerPanesConfig
        });

        this.togglerBtns = togglerBtns;

        this.panesHeight = getPanesHeight(this);
        this.renderPanesHeight();
    }

    renderPanesHeight() {
        if (this.panesHeight == null) return;
        if (!Number.isNaN(this.panesHeight)) this.element.style['height'] = `${this.panesHeight}px`;
    }

}